import { render, staticRenderFns } from "./ResultModal.vue?vue&type=template&id=a976112c&scoped=true&"
import script from "./ResultModal.vue?vue&type=script&lang=js&"
export * from "./ResultModal.vue?vue&type=script&lang=js&"
import style0 from "./ResultModal.vue?vue&type=style&index=0&id=a976112c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a976112c",
  null
  
)

export default component.exports